import {
  Component,
  Input,
  ViewChild,
  afterNextRender,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISwiperConfigs } from '@core/models/domains/slider.model';
import { SharedModule } from '@shared/shared.module';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { SwiperService } from '@shared/services/swiper-config.service';
import { HotelRepository } from '@core/services/repositories/hotel.repository';

@Component({
  selector: 'iho-slider-button-view',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './slider-button-view.component.html',
  styleUrls: ['./slider-button-view.component.scss'],
})
export class SliderButtonViewComponent {
  @ViewChild('template', { static: true }) template: any;
  @Input() dataSource: any;
  sliderConfigs!: ISwiperConfigs;
  sliderConfigsRev!: ISwiperConfigs;
  resetSwiper = signal(true);
  cdnUrl = cdnUrl;
  constructor(
    public ChainService: HotelRepository,
    private swiperService: SwiperService
  ) {
    afterNextRender(() => {
      this.resetSwiper.set(false);
      setTimeout(() => this.resetSwiper.set(true), 0);
    });
  }
  ngAfterViewInit(): void {
    let config = {
      slide: 'auto',

      pagination: {
        enabled: false,
        clickable: false,
      },
      autoplay: {
        delay: 5000,
      },
    };
    let configRev = {
      slide: 'auto',

      pagination: {
        enabled: false,
        clickable: false,
      },
      autoplay: {
        delay: 3000,
        reverseDirection: true,
      },
    };

    this.sliderConfigs = {
      swiperConfig: this.swiperService.SwiperConfig(config),
      cardType: 1,
      wrapperClasslist: ['w-full', 'h-full'],
      template: this.template,
    };

    this.sliderConfigsRev = {
      swiperConfig: this.swiperService.SwiperConfig(configRev),
      cardType: 1,
      wrapperClasslist: ['w-full', 'h-full'],
      template: this.template,
    };
  }
}
